export default "__VITE_ASSET__Dr5O82cm__"